import axios from 'axios'
import qs from 'qs'
import store from '../store'
import ev from '../common/env'
import CommUtls from '../common/CommUtls'

/**
 * 封装post请求
 * @param url
 * @param data
 * @param loading
 * @returns {Promise}
 */

var http = axios.create({
  baseURL: ev.baseUrl,
  timeout: 30000
})

export function post (url, data = {}, loading = null) {
  return new Promise((resolve, reject) => {
    console.log('url === ' + url)
    console.log('par === ' + qs.stringify(data))

    var headers = {
    }
    const token = store.state.token
    if (token) {
      headers['token'] = token
    }

    // 加签名验证
    var parmStr = CommUtls.queryParams(data) + '&key=zbsswl_key'
    data['sign'] = this.$md5(parmStr)

    http.post(url, qs.stringify(data), {
      headers: headers
    })
      .then(response => {
        if (loading !== null) {
          loading.close()
        }
        resolve(response.data)
      }, err => {
        if (loading !== null) {
          loading.close()
        }
        this.$message.error('网络好像出问题了~')
        reject(err)
      })
  })
}

export function jsonPost (url, data = {}, loading = null) {
  return new Promise((resolve, reject) => {
    console.log('url === ' + url)
    console.log('par === ' + qs.stringify(data))

    var headers = {
      'Content-Type': 'application/json',
    }
    // 添加用户id
    const token = store.state.token
    if (token) {
      headers['token'] = token
    }
    var sortParm = {}
    const res = Object.keys(data).sort()
    for (var key in res) {
      sortParm[res[key]] = data[res[key]]
    }
    console.log(sortParm)
    // 加签名验证
    var parmStr = CommUtls.queryParams(sortParm) + '&key=zbsswl_key'
    console.log(parmStr)
    headers['sign'] = this.$md5(parmStr)
    console.log(this.$md5(parmStr))
    http.post(url, data, {
      headers: headers
    }).then(response => {
      if (loading !== null) {
        loading.close()
      }
      if (response.data.code === 4) {
        this.$message.error(response.data.msg)
      }
      resolve(response.data)
    }, err => {
      if (loading !== null) {
        loading.close()
      }
      this.$message.error('网络好像出问题了~')
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/util/http.js